import config from '../config';

import { endOfDay, startOfDay } from "date-fns";

export async function fetchStatisticsGeneral(backendFetch, siteId, startDate, endDate) {
    return fetchMetering(backendFetch, 'general', siteId, startDate, endDate)
}

export async function fetchStatisticsBattery(backendFetch, siteId, startDate, endDate) {
    return fetchMetering(backendFetch, 'battery', siteId, startDate, endDate)
}

export async function fetchStatisticsProduction(backendFetch, siteId, startDate, endDate) {
    return await fetchMetering(backendFetch, 'production', siteId, startDate, endDate)
}

export async function fetchMetering(backendFetch, type, siteId, startDate, endDate){
    const fromts = Math.round(startOfDay(startDate).getTime() / 1000);
    const tots = Math.round(endOfDay(endDate).getTime() / 1000);

    const url = `${config.REACT_APP_HOST}/api/v2/statistics/${type}/${siteId}?fromts=${fromts}&tots=${tots}`;
    const f = await backendFetch(url)
    return await f.json()
}

export async function fetchOutages(backendFetch, siteId, startDate, endDate){
    const fromts = Math.round(startOfDay(startDate).getTime()/ 1000);
    const tots = Math.round(endOfDay(endDate).getTime() / 1000);

    const url = `${config.REACT_APP_HOST}/api/v2/statistics/outages/${siteId}?fromts=${fromts}&tots=${tots}`
    const f  = await backendFetch(url)
    return await f.json()
}

export async function fetchQualityRating(backendFetch, siteId, startDate, endDate){
    const fromts = Math.round(startOfDay(startDate).getTime()/ 1000);
    const tots = Math.round(endOfDay(endDate).getTime() / 1000);

    const url = `${config.REACT_APP_HOST}/api/v2/statistics/site_quality_rating/${siteId}?fromts=${fromts}&tots=${tots}`
    const f  = await backendFetch(url)
    return await f.json()    
}